import { render, staticRenderFns } from "./HipotekaTeikejas.vue?vue&type=template&id=674aa3f6&scoped=true&"
import script from "./HipotekaTeikejas.vue?vue&type=script&lang=js&"
export * from "./HipotekaTeikejas.vue?vue&type=script&lang=js&"
import style0 from "./HipotekaTeikejas.vue?vue&type=style&index=0&id=674aa3f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674aa3f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFooter,VRow,VSpacer})
